import { render, staticRenderFns } from "./MdtModalPrivacyPolicy.vue?vue&type=template&id=6ac51b20&scoped=true"
import script from "./MdtModalPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./MdtModalPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./MdtModalPrivacyPolicy.vue?vue&type=style&index=0&id=6ac51b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac51b20",
  null
  
)

export default component.exports